import { render, staticRenderFns } from "./Consulting.vue?vue&type=template&id=27aba3e9&"
import script from "./Consulting.vue?vue&type=script&lang=js&"
export * from "./Consulting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports